import React from 'react';
import { Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
	title: {
		fontWeight: 'bold'
	},
	content: {
		opacity: '50%'
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		marginTop: 50,
		justifyContent: 'center',
	},
	spacing: {
		display: 'block',
		height: '16px',
	  }
}));

const UnauthorizedErrorPage = () => {
	const classes = useStyles();
	return (
		<Typography variant='h2' className={classes.container}>
			<span className={classes.title}>Oops, something went wrong!</span>
			<span className={classes.spacing}></span>
			<span className={classes.content}>I’m sorry, you don't have access to this part of the site.</span>
		</Typography>
	);
};

export default UnauthorizedErrorPage;
